export default __webpack_public_path__ + "static/media/homepageBanner.f87698c1.png";